var map = {
	"./Achievement.mp3": 8569,
	"./Announcer Congratulations Youve Just Won 1.wav": 86529,
	"./Announcer Lets get ready to rumble 2.mp3": 15385,
	"./Bonus Coin Success.mp3": 96851,
	"./Crystal Health Boost.wav": 30172,
	"./Karate 6031_54_3 2.wav": 82501,
	"./Koto Finish.wav": 52518,
	"./Male Lets Do This 2.mp3": 31628,
	"./Male Voice Terrific 2.mp3": 79517,
	"./Man Saying Fantastic.mp3": 98333,
	"./Merch Complete.wav": 51174,
	"./Mountain Audio - Digital Casino Short Roulette Spin 1.mp3": 69113,
	"./New Message 3.mp3": 38521,
	"./Pro Magic Reveal.mp3": 46838,
	"./Pro Magic Reveal.wav": 53242,
	"./Process Success.wav": 63828,
	"./Purchase Complete.mp3": 22607,
	"./Puzzle_Game_PowerUp_Light_02.wav": 70913,
	"./Puzzle_Game_PowerUp_Light_03.wav": 19278,
	"./Puzzle_Game_PowerUp_Light_04.wav": 98617,
	"./Puzzle_Game_Tech_PowerUp_Large_01.wav": 29659,
	"./Puzzle_Game_Tech_PowerUp_Large_02.wav": 97707,
	"./Puzzle_Game_Tech_PowerUp_Large_03.wav": 74138,
	"./Puzzle_Game_UI_PowerUp_03.wav": 5134,
	"./Quest_Game_UI_Bass_Tap_Button_Click_1_Snap.wav": 11926,
	"./Quest_Game_UI_Bass_Tap_Button_Click_2_Snap.wav": 95002,
	"./Removing a Plug.mp3": 728,
	"./Score Increasing 1.mp3": 82916,
	"./Switch-Click_TTX042002.wav": 22575,
	"./Win Game Sound.mp3": 61314,
	"./Winner Announcement With Drum Roll.mp3": 67892,
	"./Wrestling_Coach_Constant_MMA_OCM-0046-134 2.wav": 35191,
	"./confetti_gun.mp3": 95041,
	"./confetti_gun.wav": 1498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29743;